import React from "react";
import EmailAnalytics from "../../../components/Pages/Campaign/General/EmailAnalytics";

const EmailsAnalytics = () => {
  return (
    <div>
      <EmailAnalytics />
    </div>
  );
};

export default EmailsAnalytics;
